import React, { useState, useEffect } from 'react'
import { Table, Image, OverlayTrigger, FormControl, Button, Dropdown, Collapse } from 'react-bootstrap'
import '../../index.css'

import { FetchInventory, FetchLocalizedAnalysis, FetchArticleTypeImages, FetchStocksReport, FetchRegisterStocksReport, FetchCreateStartFullInventoryTransaction, FetchStartedFullInventoryTransaction, FetchUpdateTransactionDraft, FetchCreateInventoryTransaction } from '../../fetcher'
import { getTotal, getSizeNumbers, getStringsSizeEntries } from '../presentational-components/TableComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'
import { RenderImage } from '../presentational-components/ImageViewer'
import DeliveryOrderContainer from './DeliveryOrderContainer'
import MaintainStock from './MaintainStock'
import TransactionView from './TransactionView'
import InventoryReport from './InventoryReport'
import { CustomToggle } from '../presentational-components/simple-objects/CustomDropDown'
import { ExportCSV } from '../presentational-components/ExportCSV'
import moment from 'moment'
import 'moment/locale/de'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { useSortSalesReport } from '../presentational-components/tablehooks'
import { useFilterReport } from '../presentational-components/filterutils'
import { parseFloatCurrency } from '../presentational-components/floatnumberparsing'






import InventoryPartTransactionsView from './InventoryPartTransactionsView'
moment.locale('de')

const Inventory1 = () => {
    const [tabNumber, setTabNumber] = useState(0)
    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [inventoryCreationSuccessfull, setInventoryCreationSuccessfull] = useState(false)
    const [articleDataReady, setArticleDataToReady] = useState(false)
    const [childReload, setChildReload] = useState(false)

    const [stocksReport, setStocksReport] = useState([])
    const [sortedReports, setSortedReports] = useState([])
    const [filteredReports, setFilteredReports] = useState([])
    
    const [options, setOptions] = useState([])
    const [designerSelection, setDesignerSelection] = useState("")
    const [showEmptyStocks, setShowEmptyStocks] = useState(false)

    const { sortSalesReport } = useSortSalesReport(showEmptyStocks ? [...stocksReport] : [...stocksReport].filter(x => x.TotalAmount !== 0), setSortedReports)
    const { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput } = useFilterReport()
    const [searchInput, setSearchInput] = useState("")

    const [localizedAnalysis, setLocalizedAnalysis] = useState([])

    const [analysis, setAnalysis] = useState(false)

    const [taskName, setTaskName] = useState("Inventory unbekannte Task")

    const controller = new AbortController()
    const signal = controller.signal

    const [showAllArticles, setShowAllArticles] = useState(false)
    const toggleShowAllArticles = () => {
        setTabNumber(prev => prev != 1 ? 1 : 2)
    }

    const handleSetAnalysis = () => {
        setTabNumber(prev => prev != 2 ? 2 : 1)
    }

    useEffect(() => {
        let stocksReportTemp = showEmptyStocks ? [...stocksReport] : [...stocksReport].filter(x => x.TotalAmount !== 0)
        setFilteredReports(stocksReportTemp)
        setSortedReports(stocksReportTemp)
    }, [stocksReport])

    useEffect(() => {
        let filteredReport = filterReportBySearchInput([...sortedReports], searchInput)
        //filteredReport = filterReportByDateInput(filteredReport, dateSelect)
        //filteredReport = filterReportBySelectInput(filteredReport, statusSelect)
        console.log("useEffect filteredReports")
        console.log(filteredReport)
        setFilteredReports(filteredReport)
    }, [searchInput, sortedReports])

    useEffect(() => {
        setTaskName("Auswertungsoptionen werden geladen")
        FetchRegisterStocksReport(setOptions, openAlert, signal, "Inventory1")

        return () => {
            controller.abort()
        }
    }, [])

    const loadReport = (designerSysId) => {
        setTaskName("Auswertung wird geladen")
        let requestParam = {
            "Name": options[0].Name,
            "ReportId": options[0].ReportId.toString(),
            "DesignerSysId": designerSysId
        }
        FetchStocksReport(setStocksReport, requestParam, openAlert, signal, "Inventory1")
    }

    const handleSetDesignerSelection = (designerSelect) => {
        let selectedDesigner = options[0].ReportParameters.find(y => y.Order === 1).Designers.find(x => x.Name.trim() === designerSelect.trim())
        if (selectedDesigner !== undefined) setDesignerSelection(selectedDesigner.DesignerSysId)
    }

    const loadDesignerSelection = () => {
        console.log("loadDesignerSelection", designerSelection)
        if (options !== null && options[0] !== undefined) {
            let designers = options[0].ReportParameters.find(y => y.Order === 1).Designers
            let designerNames = designers.map(x => x.Name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let all = designerNames.splice(designerNames.findIndex(a => a.includes('Alle')), 1)
            designerNames.splice(0, 0, all[0])
            return (
                <FormControl className="filterForm reportSelect" defaultValue={designers.find(x => x.DesignerSysId == designerSelection) != null ? designers.find(x => x.DesignerSysId == designerSelection).Name : ""} as="select" size="sm" onChange={(e) => handleSetDesignerSelection(e.target.value)}>
                    {designerNames.map(x => <option>{x}</option>)}
                </FormControl>
            )
        }
    }

    const handleReportLoad = () => {
        loadReport(designerSelection)
    }

    const handleSetLocalizedAnalysis = (newLocalizedAnalysis) => {
        const localizedAnalysisCopy = [...localizedAnalysis]
        localizedAnalysisCopy.push(newLocalizedAnalysis[0])

        console.log("handleSetLocalizedAnalysis ", localizedAnalysisCopy)

        setLocalizedAnalysis(localizedAnalysisCopy)
    }

    const getLocalizedAnalysis = (articleTypeSysId, size) => {
        console.log("getLocalizedAnalysis")
        console.log(articleTypeSysId, size)
        FetchLocalizedAnalysis(articleTypeSysId, size, handleSetLocalizedAnalysis, openAlert)
    }

    const addingImages = (articleTypeImages) => {
        let copiedFetchedStock = [...stocksReport]
        articleTypeImages.forEach(image => copiedFetchedStock.filter(x => x.ArticleSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setStocksReport(copiedFetchedStock)
        //setFetchedStockByDesigner(copiedFetchedStock)
    }

    const handleShowEmptyStock = () => {
        const emptyStockTemp = !showEmptyStocks
        setShowEmptyStocks(!showEmptyStocks)

        if (emptyStockTemp) {
            let filteredReport = [...stocksReport]
            //setFilteredReports(filteredReport)
            setSortedReports(filteredReport)
        } else {
            let filteredReport = [...stocksReport].filter(x => x.TotalAmount !== 0)
            //setFilteredReports(filteredReport)
            setSortedReports(filteredReport)
        }
    }

    const [disableExport, setDisableExport] = useState(true)

    const [isFaexStorage, setIsFaexStorage] = useState(false)

    const [templateToUse, setTemplateToUse] = useState()
    const [draftToUpdate, setDraftToUpdate] = useState()
    const [isCorrectionDraft, setIsCorrectionDraft] = useState(false)

    const [showDeliveryDraftMask, setShowDeliveryDraftMask] = useState(false)
    const handleShowDeliveryDraftMask = () => {
        setShowDeliveryDraftMask(true)
    }
    const handleCloseDeliveryDraftMask = () => {
        setShowDeliveryDraftMask(false)
    }

    const [showForwardDeliveryMask, setShowForwardDeliveryMask] = useState(false)
    const handleShowForwardDeliveryMask = () => {
        setShowForwardDeliveryMask(true)
    }
    const handleCloseForwardDeliveryMask = () => {
        setShowForwardDeliveryMask(false)
    }

    const [showInventoryTransactionMask, setShowInventoryTransactionMask] = useState(false)

    const handleShowInventoryTransactionMask = () => {
        setTabNumber(prev => prev != 3 ? 3 : 0)
    }

    const handleShowInventoryTransactionMask1 = () => {
        setTabNumber(prev => prev != 4 ? 4 : 0)
    }
    const handleCloseInventoryTransactionMask = () => {
        setShowInventoryTransactionMask(prev => prev = false)
    }

    const updateTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        console.log("updateTransactionDraft ", transactionDraft)
        setDraftToUpdate(transactionDraft)
        setChildReload(true)

        //Type = "CorrectionForNewArrivals" || "NewArrivals"
        if (transactionDraft.Type == "CorrectionForNewArrivals") setIsCorrectionDraft(true)
        else setIsCorrectionDraft(false)

        setShowDeliveryDraftMask(true)
        
    }

    const openNewTransactionTemplate = (e, transaction) => {
        e.preventDefault()
        console.log("Transaction Template: ")
        console.log(transaction)
        setTemplateToUse(transaction)
        setChildReload(true)

        setShowForwardDeliveryMask(true)
    }

    useEffect(() => {
        //FetchInventory(setFetchStock, openAlert, setArticleDataToReady)

        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setIsFaexStorage(true)
        }
    }, []);

    useEffect(() => {
        if (articleDataReady) {
            console.log("Die Bilder werden geladen")
            setTaskName("Die Bilder werden geladen")
            FetchArticleTypeImages(stocksReport.map(x => x.ArticleSysId.toString()), addingImages, openAlert, "Inventory1")
        }
    }, [articleDataReady])

    useEffect(() => {
        console.log("setFetchedStockByDesigner")
        if (stocksReport.length > 0) {
            setDisableExport(false)
        } else setDisableExport(true)
    }, [stocksReport])

    const [startedFullInventory, setStartedFullInventory] = useState(null) // ZD. null means it is not loaded! If it is loaded and the transaction does not exists it is set to {}

    useEffect(() => {
        console.log("showInventoryTransactionMask2", showInventoryTransactionMask, Date.now())
        if (tabNumber == 3) {
            console.log("showInventoryTransactionMask", showInventoryTransactionMask, Date.now())
            setTaskName("Der Inventur-Entwurf wird geladen")
            FetchStartedFullInventoryTransaction(setStartedFullInventory, openAlert, () => { }, signal, "InventoryDraft")
        }
    }, [tabNumber])


    useEffect(() => {
        console.log("startedFullInventory1", startedFullInventory)
    }, [startedFullInventory])

    const getCsvData = () => {
        let filteredReport = [...filteredReports]
        //filteredReport = filteredElementsForCsv([...filteredReports])

        let csvData = filteredReport.map(x =>
        ({
            "Artikelnr. FAEX": x.FAEXArticleNumber,
            "Artikelnr. Designer": x.ArticleNumberDesigner,
            "Artikelname": x.ArticleName,
            "Farbe": x.Colour,
            //"Beschreibung": x.DescriptionDesigner,
            "Größe": x.Size,
            "Gesamt": x.TotalAmount,
            "Extern": x.ExternalAmount,
            "Verkauft": x.SoldAmount,
            "Lager": x.StorageAmount,
            "Vk-Preis": x.DefaultSalePrice,
        }))
        return (csvData)
    }

    const reloadAfterSuccess = () => {
        setInventoryCreationSuccessfull(true)
        reload()
    }

    const reload = () => {
        console.log("showInventoryTransactionMask2 2", showInventoryTransactionMask, Date.now())
        FetchStartedFullInventoryTransaction(setStartedFullInventory, openAlert, () => { }, signal, "InventoryDraft")
    }

    const ShowTransactionView = () => {
        //setTaskName("Die Bestandstransaktionen werden geladen")
        return (
            <div>
                <TransactionView parentReload={childReload} updateTransactionDraft={updateTransactionDraft} openNewTransactionTemplate={openNewTransactionTemplate} signal={signal} area={"Inventory"} />
                <LoadingSpinner task={"Die Bestandstransaktionen werden geladen"} area={"Inventory"} />
            </div>
        )
    }

    const ShowAllArticles = () => {
        console.log("ShowAllArticles")
            //< Dropdown className = "form searchBar" >
            //            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-boutique" >
            //                {designerNameHeader}
            //            </Dropdown.Toggle>

            //            <Dropdown.Menu className="article-dropdown">
            //                <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={(e) => setDesignerFilterInput(e.target.value)}></FormControl>
            //                {
            //                    [...new Set(fetchedStock.map(x => x.DesignerName))].filter(x => x.toLowerCase().includes(designerFilterInput.toLowerCase()))
            //                        .sort((a, b) => a.localeCompare(b))
            //                        .map(designer =>
            //                            <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetFetchedStockByDesigner(designer)}>
            //                                {designer}
            //                            </Dropdown.Item>
            //                        )
            //                }

            //            </Dropdown.Menu>
            //    </Dropdown >

        return (
            <>
                <div className="report-menu searchBar">
                    <div className="inline">
                        {loadDesignerSelection()}
                        &nbsp;&nbsp;
                        <Button variant="light" size="sm" className="form filter-button form-control sales-report-btn" onClick={() => handleReportLoad()}>Auswertung laden</Button>
                    </div>
                </div>
                <br />

                <FormControl className="globalSearch searchBar" as="input" placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                
                <div className="inline-forms">
                    <ExportCSV className="searchBar" disabled={disableExport} csvData={getCsvData()} fileName={"Bestand_" + designerSelection} />
                    <Button variant="secondary" className="empty-stock-btn" onClick={handleShowEmptyStock}>{showEmptyStocks ? "Nur Volle Bestände" : "Leere Bestände"}</Button>
                </div>

                <div className="tablet-transactions">
                    {returnFilteredElements(filteredReports, filteredReports.length === 0 && stocksReport.length > 0)}
                </div>
            </>)
    }

    const [filterInput, setFilterInput] = useState("")

    /**
    * Handles the input for the Search Control
    * @param  e - event handler with the users input value
    */
    const handleSearchInput = (e) => {
        let input = e.target.value
        setTimeout(() => setSearchInput(input), 500)
    }

    const [showAddStockMask, setShowAddStockMask] = useState(false)
    const toggleShowAddStockMask = () => {
        setShowAddStockMask(!showAddStockMask)
    }
    const handleShowAddStockMask = () => {
        setShowAddStockMask(true)
    }
    const handleCloseAddStockMask = () => {
        setShowAddStockMask(false)
    }

    const [showLowerStockMask, setShowLowerStockMask] = useState(false)
    const toggleShowLowerStockMask = () => {
        setShowLowerStockMask(!showLowerStockMask)
    }
    const handleShowLowerStockMask = () => {
        setShowLowerStockMask(true)
    }
    const handleCloseLowerStockMask = () => {
        setShowLowerStockMask(false)
    }

    const emptyFilteredList = (isEmpty) => {
        return isEmpty ? "Keine Artikel im Lager." : ""
    }

    const [selectFilterInput, setSelectFilterInput] = useState("")
    const selectFilteredElements = (e) => {
        setSelectFilterInput(e.target.value)
    }

    const [externalExpandedRows, setExternalExpandedRows] = useState([])

    const expandExternalAnalysis = (article) => {
        const expandedRowsCopy = [...externalExpandedRows]
        if (expandedRowsCopy.includes(article)) {
            expandedRowsCopy.splice(expandedRowsCopy.indexOf(article), 1)
        } else {
            expandedRowsCopy.push(article)
            getLocalizedAnalysis(article.ArticleTypeSysId, article.Size)
        }
        setExternalExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedExternalAnalysis = (article) => {
        return (externalExpandedRows.includes(article))
    }

    const [soldExpandedRows, setSoldExpandedRows] = useState([])

    const expandSoldAnalysis = (article) => {
        const expandedRowsCopy = [...soldExpandedRows]
        if (expandedRowsCopy.includes(article)) {
            expandedRowsCopy.splice(expandedRowsCopy.indexOf(article), 1)
        } else {
            expandedRowsCopy.push(article)
            getLocalizedAnalysis(article.ArticleTypeSysId, article.Size)
        }
        setSoldExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedSoldAnalysis = (article) => {
        return (soldExpandedRows.includes(article))
    }

    const getLocalizedExternalDataForRow = (article) => {
        let data = []
        let dataLocalized = localizedAnalysis.find(x => x.FAEXArticleTypeSysId === article.ArticleTypeSysId && x.Size === article.Size)
        if (dataLocalized != undefined) {
            data = dataLocalized.LocalizedAnalysis.AtExternalStorage.filter(x => x.ArticleTypeSysId === article.ArticleTypeSysId && x.SizeValue === article.Size)
        }
        return data
    }

    const getLocalizedSoldDataForRow = (article) => {
        let data = []
        let corrections = []
        let returns = []
        let dataLocalized = localizedAnalysis.find(x => x.FAEXArticleTypeSysId === article.ArticleTypeSysId && x.Size === article.Size)
        if (dataLocalized != undefined) {
            data = dataLocalized.LocalizedAnalysis.Sold.filter(x => x.ArticleTypeSysId === article.ArticleTypeSysId && x.SizeValue === article.Size)
            corrections = dataLocalized.LocalizedAnalysis.CorrectedInSaleTransaction.filter(x => x.ArticleTypeSysId === article.ArticleTypeSysId && x.SizeValue === article.Size)
            returns = dataLocalized.LocalizedAnalysis.Returned.filter(x => x.ArticleTypeSysId === article.ArticleTypeSysId && x.SizeValue === article.Size)
        }
        return [data, corrections, returns]
    }

    const createNewInventory = (transaction) => {
        FetchCreateStartFullInventoryTransaction(transaction, reload, openAlert, () => { }, signal, "StartedInventoryDraft");
    }

    const updateStartedInventory = (transaction) => {
        FetchUpdateTransactionDraft(transaction, transaction.AbstractTransactionSysId, reload, openAlert, () => { }, () => { }, () => { })
    }

    const createInventory = (sysId, area) => {
        FetchCreateInventoryTransaction(sysId, reloadAfterSuccess, openAlert, () => { }, () => { }, () => { }, signal, "StartedInventoryDraft")
    }

    const returnFilteredElements = (elements, empty) => {
        return (
            <>
                {emptyFilteredList(empty)}
                <Table className='table table-striped table-sm tablet-table table-width-narrow' aria-labelledby="tabelLabel">
                    <thead className="sticky-table-header"><tr>
                        <th>Ansicht</th>
                        <th>Designername
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Designer')}>&#8593; &#8595;</a>
                        </th>
                        <th>Artikelnr.
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'FAEXArticleNumber')}>&#8593; &#8595;</a>
                        </th>
                        <th>Artikelnr. Designer
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a>
                        </th>
                        <th>Artikeltyp
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleName')}>&#8593; &#8595;</a>
                        </th>
                        <th>Farbe
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Colour')}>&#8593; &#8595;</a>
                        </th>
                        <th>Größe
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Size')}>&#8593; &#8595;</a>
                        </th>
                        <th>Gesamt
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'TotalAmount')}>&#8593; &#8595;</a>
                        </th>
                        <th>Extern
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ExternalAmount')}>&#8593; &#8595;</a>
                        </th>
                        <th>Verkauft
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'SoldAmount')}>&#8593; &#8595;</a>
                        </th>
                        <th>Lager
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'StorageAmount')}>&#8593; &#8595;</a>
                        </th>
                        <th>Verkaufspreis
                            <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'DefaultSalePrice')}>&#8593; &#8595;</a>
                        </th>
                        {/*<th>{SizeCategory()}</th>*/}
                    </tr></thead>

                    <tbody>
                        {elements.map(article =>
                        <>                            
                                {/*{(stockItem.map(article =>*/}
                                <tr>
                                    <td>{RenderImage(article.Image)}</td>
                                    <td>{article.Designer}</td>
                                    <td>{article.FAEXArticleNumber}</td>
                                    <td>{article.ArticleNumberDesigner}</td>
                                    <td>{article.ArticleName}</td>
                                    <td>{article.Colour}</td>
                                    <td>{article.Size}</td>
                                    <td className="numberColumn">{article.TotalAmount}</td>

                                    {article.ExternalAmount > 0 && isFaexStorage ?
                                        <td><Button variant="light" onClick={() => expandExternalAnalysis(article)} aria-controls={article}
                                            aria-expanded={!getIsExpandedExternalAnalysis(article)} className="table-card-header localized-analysis-btn">
                                            {article.ExternalAmount}
                                        </Button></td> :
                                        <td className="numberColumn">{article.ExternalAmount}</td>}

                                    {article.SoldAmount > 0 && isFaexStorage ?
                                        <td><Button variant="light" onClick={() => expandSoldAnalysis(article)} aria-controls={article}
                                            aria-expanded={!getIsExpandedSoldAnalysis(article)} className="table-card-header localized-analysis-btn">
                                            {article.SoldAmount}
                                        </Button></td> :
                                        <td className="numberColumn">{article.SoldAmount}</td>}


                                    <td className="numberColumn">{article.StorageAmount}</td>
                                    <td className="numberColumn">{parseFloatCurrency(article.DefaultSalePrice)}</td>
                                    {/*<td></td>*/}
                                    {/*{getTotal(article.Stocks)}*/}
                                    {/*{getSizeNumbers(article.Stocks)}*/}
                                </tr>
                                {/*))}*/}

                                <Collapse in={getIsExpandedExternalAnalysis(article)}>
                                    <tr>
                                    <td colSpan="6" className="td-nomargin">
                                        <div>
                                            <tr>
                                                <th className="placeholder-tablecell"></th><th>Extern:</th>
                                                <th>Wo</th>
                                                <th className="numberColumn">Wieviel</th>
                                            </tr>
                                            {getLocalizedExternalDataForRow(article).map(x => (
                                                <tr>
                                                    <td className="placeholder-tablecell"></td><td></td>
                                                    <td>{x.StorageName}</td>
                                                    <td className="numberColumn">{x.Amount}</td>
                                                </tr>
                                            ))}
                                        </div>
                                        </td>
                                        </tr>
                                </Collapse>

                                <Collapse in={getIsExpandedSoldAnalysis(article)}>
                                    <tr>
                                    <td colSpan="7" className="td-nomargin">
                                        <div>
                                            <tr>
                                                <th className="placeholder-tablecell"></th><th>Verkauft:</th>
                                                <th>Wo</th>
                                                <th className="numberColumn">Wieviel</th>
                                                <th>Verkaufsdatum</th>
                                                <th>Korrigiert/Zurückgeschickt</th>
                                            </tr>
                                            {getLocalizedSoldDataForRow(article)[0].map(x => (
                                                <tr>
                                                    <td className="placeholder-tablecell"></td><td></td>
                                                    <td>{x.StorageName}</td>
                                                    <td className="numberColumn">{x.Amount}</td>
                                                    <td>{moment(x.DateOfSaleOrReturn).format("DD.MM.YYYY")}</td>
                                                    <td>{getLocalizedSoldDataForRow(article)[1].find(corrected => corrected.InitialSaleSysId === x.TransactionSysId) !== undefined ? "Ja" : ""}</td>
                                                </tr>
                                            ))}
                                        </div>
                                        </td>
                                        </tr>
                                </Collapse>
                                
                        </>
                        )}
                        <tr className="stockReport-row">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>Summe: </td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.TotalAmount)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.ExternalAmount)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.SoldAmount)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.StorageAmount)).reduce((a, b) => a + b, 0)}</td>
                            <td></td>
                        </tr>
                    </tbody>
                    
                </Table>
            </>
        )
        
    }

    const loadSelectedTab = (tabNumber, startedFullInventory) => {
        console.log("loadSelectedTab", tabNumber, startedFullInventory)
        switch (tabNumber) {
            case 1:
                return (ShowAllArticles())
            case 2:
                return (ShowTransactionView())
            case 3:
                return (startedFullInventory != null ?
                    <>
                        <LoadingSpinner task={taskName} area={"StartedInventoryDraft"} signal={signal}/>
                        <InventoryPartTransactionsView inventoryCreationSuccessfull={inventoryCreationSuccessfull} inventoryTransaction={startedFullInventory} createStartFullInventory={createNewInventory} updateStartedFullInventory={updateStartedInventory} createInventory={createInventory} reloadParent={reload} reloadAfterSuccess={reloadAfterSuccess} setTaskName1={setTaskName} />
                    </>
                    :
                    <LoadingSpinner task={taskName} area={"InventoryDraft"} signal={signal}/>)
            case 4:
                return (<InventoryReport />)
            default:
                return (<></>)
        }
    }
    
    return (
        <div>
            <div className="tablet-center">
                <h1 className="tablet-center">Artikel</h1>
                <div className="flex-linebreak"></div>
                {isFaexStorage && <Button variant="secondary" className="new-transaction-btn" onClick={handleShowAddStockMask}>Neuer Bestand</Button>}
                &nbsp;
                {isFaexStorage && <Button variant="secondary" className="new-transaction-btn" onClick={handleShowLowerStockMask}>Bestandskorrektur</Button>}
                &nbsp;
                <Button variant="secondary" className="new-transaction-btn" onClick={toggleShowAllArticles}>Alle Artikel</Button>
                &nbsp;
                <Button variant="secondary" className="booking-btn" onClick={() => handleSetAnalysis()}>Bestandstransaktionen</Button>
                &nbsp;
                <Button variant="secondary" className="booking-btn" onClick={() => handleShowInventoryTransactionMask()}>Inventur</Button>
                &nbsp;
                <Button variant="secondary" className="booking-btn" onClick={() => handleShowInventoryTransactionMask1()}>Vorherige Inventur</Button>
            </div>

            <div className="flex-linebreak"></div>

            <div className="flex-linebreak"></div>

            {
                loadSelectedTab(tabNumber, startedFullInventory)
            }

            <ModalComponent handleShow={showAddStockMask} handleClose={handleCloseAddStockMask}
                reload={reload} modalTitle="Neuer Bestand" modalBody={<MaintainStock handleCloseMask={handleCloseAddStockMask} reloadParent={() => setChildReload(!childReload) } />} tabletView={true} />

            <ModalComponent handleShow={showLowerStockMask} handleClose={handleCloseLowerStockMask}
                reload={reload} modalTitle="Bestandskorrektur" modalBody={<MaintainStock handleCloseMask={handleCloseLowerStockMask} transactionType={"CorrectionForNewArrivals"} reloadParent={() => setChildReload(!childReload)} />} tabletView={true} />

            <ModalComponent handleShow={showDeliveryDraftMask} handleClose={handleCloseDeliveryDraftMask}
                reload={reload} modalTitle={isCorrectionDraft ? "Bestandskorrektur-Entwurf bearbeiten" : "Bestands-Entwurf bearbeiten"} modalBody={<MaintainStock handleCloseMask={handleCloseDeliveryDraftMask} transactionType={draftToUpdate === undefined ? "NewArrivals" : draftToUpdate.Type} reloadParent={() => setChildReload(!childReload)} draft={draftToUpdate} />} tabletView={true} />

            <ModalComponent handleShow={showForwardDeliveryMask} handleClose={handleCloseForwardDeliveryMask}
                reload={reload} modalTitle="Lieferschein weiterleiten" modalBody={<DeliveryOrderContainer handleCloseMask={handleCloseForwardDeliveryMask} reloadParent={() => setChildReload(!childReload)} template={templateToUse} />} tabletView={true} />

            {/*<ModalComponent handleShow={showInventoryTransactionMask} handleClose={handleCloseInventoryTransactionMask}*/}
            {/*    reload={reload} modalTitle="Neue Inventur" modalBody={<MaintainStock handleCloseMask={handleCloseInventoryTransactionMask} transactionType={"Inventory"} reloadParent={reload} />} tabletView={true} />*/}


            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            <LoadingSpinner task={taskName} area={"Inventory1"} />
        </div>
    )
}

export default Inventory1